export const ModifierTypes = Object.freeze({
    SINGLE: 'SINGLE',
    MULTIPLE: 'MULTIPLE',
});
export type ModifierType = (typeof ModifierTypes)[keyof typeof ModifierTypes];
